import React from "react";
import GreenLocPin from "../../../assets/location_green.png";
import GreyLocPin from "../../../assets/location_grey.png";
import { TCText } from "../../TCText/TCText";
import { Colors } from "../../../utils/colors";

type props = {
  onClick?: () => void;
  isSelected: boolean;
  location: string;
};

export const ServiceLocation: React.FC<props> = ({
  onClick,
  isSelected,
  location,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        position: "relative",
        flexDirection: "row",
        gap: 10,
        alignItems: "center",
        padding: 15,
        backgroundColor: isSelected ? Colors.lightGreyBackground : undefined,
        borderRadius: 100,
        marginBottom: 15,
        cursor: "pointer",
      }}>
      <img
        src={isSelected ? GreenLocPin : GreyLocPin}
        alt=""
        style={{ width: 22, height: 22 }}
      />
      <TCText
        style={{ fontWeight: isSelected ? 600 : 400, fontSize: 14 }}
        value={location}
      />
    </div>
  );
};
